import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { State } from '@store/index';

/**
 * ThemeManager component that synchronizes the Redux theme state with the body data-theme attribute
 * This ensures that CSS selectors targeting body[data-theme="light"] and body[data-theme="dark"] work correctly
 */
export const ThemeManager: React.FC = () => {
  const theme = useSelector((state: State) => state.flow.theme);

  useEffect(() => {
    // Set the data-theme attribute on the body element
    document.body.setAttribute('data-theme', theme);
  }, [theme]);

  return null;
};
